<template>
	<f7-page id="page-sendmoney-beneficiary" name="sendmoney-beneficiary" @page:beforeout="handleBeforeOut()" @page:afterin="afterin">
    <!-- TOP NAV BAR -->
		<f7-navbar class="no-border view-mobile">
			<div class="navbar-inner">
				<f7-nav-left class="back-button">
					<f7-link @click="backButton" color="black"><i class="f7-icons">chevron_left</i></f7-link>
				</f7-nav-left>
				<f7-nav-right><f7-link></f7-link></f7-nav-right>
			</div>
		</f7-navbar>

    <f7-block>
      <f7-col class="wandr-level-4">{{$t('sendmoney-select-recipient')}}</f7-col>
    </f7-block>

    <!-- BENEFICIARY LIST -->
    <f7-block>
      <beneListComponent :isSearchBar="true" :isCreateTrx="true" />

      <f7-button class="mb-sm view-desktop mt-xxl" large fill @click="addBeneficiary()">
        <span>{{$t('sendmoney-add-recipient')}}</span>
      </f7-button>
    </f7-block>

    <!-- BOTTOM BUTTON -->
    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
      <f7-button class="mb-sm" large fill @click="addBeneficiary()">
        <span>{{$t('sendmoney-add-recipient')}}</span>
      </f7-button>
    </f7-toolbar>

	</f7-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import beneListComponent          from '@/components/beneficiary-list-1'

export default {
  data() {
    return {
      routerTo : ""
    }
  },
  components: {
    beneListComponent
  },
  computed: {
    ...mapGetters('auth', [
      'authenticating',
      'authenticationError',
      'authenticationErrorCode',
      'authenticationSuccess'
    ])
  },
  mounted() {
    // Required for everypage. Toggle desktop-view footer.
    this.toggleFooterVisibility(false)
    this.$f7.$('.page-content').on('scroll', (e) => {
      this.toggleFooterVisibility(e.target)
    })

    this.routerTo = this.$store.state.beneficiary.routerTo
  },

  methods: {
    ...mapActions('auth', ['login']),

    afterin(){
      window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
    },
    addBeneficiary(){
      this.$store.state.beneficiary.routerTo = (this.$store.state.beneficiary.routerTo == "fxcalculator") ? 'fxcalculator' : 'sendMoney'
      this.$f7router.navigate("/beneficiary-new-details");
    },

    backButton() {
      switch(this.routerTo) {
        case "confirm"      : this.$f7router.navigate("/sendmoney/confirmation"); break;
        case "fxcalculator" : this.$f7router.back(); break;
        case "home"         : this.$f7router.back(); break;
        default             : this.$f7router.back("/home",{force:true}); break;
      }
    },

    handleBeforeOut(){
      if(this.$f7router.url != "/sendmoney/enter-amount" && this.$f7router.url != "/beneficiary-new-details"){
        this.$store.state.beneficiary.routerTo = ''
      }
    }
  },
}
</script>